import Avatar from '@mui/material/Avatar';
import { avatarColorFromName } from 'src/shared/helpers/avatarColor';

type MemberAvatarProps = {
  firstName: string;
  lastName: string;
};

const MemberAvatar = (props: MemberAvatarProps) => {
  const { firstName, lastName } = props;

  enum AvatarSizes {
    xs = 60,
    sm = 80,
    md = 120,
  }

  const stringAvatar = (fName: string, lName: string) => {
    return {
      sx: {
        bgcolor: avatarColorFromName(`${fName} ${lName}`),
        width: {
          xs: AvatarSizes.xs,
          sm: AvatarSizes.sm,
          md: AvatarSizes.md,
        },
        height: {
          xs: AvatarSizes.xs,
          sm: AvatarSizes.sm,
          md: AvatarSizes.md,
        },
        fontSize: {
          xs: AvatarSizes.xs / 2,
          sm: AvatarSizes.sm / 2,
          md: AvatarSizes.md / 2,
        },
      },
      children: `${fName.length > 0 ? fName.charAt(0) : ''}${lName.length > 0 ? lName.charAt(0) : ''}`,
    };
  };

  return <Avatar {...stringAvatar(firstName, lastName)} />;
};

export default MemberAvatar;
